module.exports = __webpack_public_path__ + "static/background2-585ddb84f803bb01afd097b2d4768b63.svg";